module.exports = __webpack_public_path__ + "static/media/ThePowerOfNature.f3ae0013.png";